import React, { useEffect, useState } from 'react'
import PropTypes from 'prop-types'
import Dialog from '../../../../components/ModalDialog'
import CreateIcon from '../../../../assets/icons/settingsCorner/iconsCreate'
import { StyledDivContent, StyledInputTitle, sxInput } from '../../styled'
import AutoComplete from '../../../../components/AutoComplete'

function DriverModal({
  open,
  handleClose,
  modalTitle,
  drivers,
  keys,
  fetchKeys,
  searchKeys,
  fetchDrivers,
  assign,
  isLoadingAssign,
  success,
  errorMessage,
  fetchMoreKeys,
  keysCount,
}) {
  const [driver, setDriver] = useState('')
  const [select, setSelect] = useState(false)
  const [init, setInit] = useState(false)
  const [key, setKey] = useState('')
  const [offset, setOffset] = useState(25)
  const [searchKey, setSearchKey] = useState('')
  const UserId = String(JSON.parse(localStorage.getItem('currentUser'))?.id)
  const date = new Date().toISOString()

  useEffect(() => {
    const filter = {
      actif: true,
    }
    fetchDrivers(filter)
    fetchKeys()
    setInit(true)
  }, [])

  useEffect(() => {
    const delayDebounceFn = setTimeout(() => {
      if (searchKey.length > 0 && !select) {
        searchKeys(searchKey)
        setOffset(25)
      } else {
        if (init) {
          searchKeys('')
        }
      }
    }, 500)

    return () => clearTimeout(delayDebounceFn)
  }, [searchKey])

  const onChangeSearchKey = (value) => {
    setSelect(false)

    if (value) {
      let val = value.trim()
      setSearchKey(val)
    } else {
      setKey('')
      setSearchKey('')
    }
  }

  useEffect(() => {
    if (success) {
      handleClose()
    }
  }, [success])

  const onSelect = (value) => {
    if (value) {
      setDriver(value)
    }
  }
  const onSelectKey = (value) => {
    if (value) {
      setKey(value)
      setSearchKey('')
      setSelect(true)
    }
  }

  const onChangeAssign = () => {
    const data = {
      affectDate: date,
      keyId: key.id,
      userId: String(UserId),
      driverId: String(driver.id),
    }
    assign(data)
  }
  const loadMoreKeys = (event) => {
    if (
      Math.round(event.target.scrollHeight - event.target.scrollTop) ==
        event.target.clientHeight &&
      keysCount >= offset
    ) {
      fetchMoreKeys(offset + 25)
      setOffset(offset)
    }
  }
  return (
    <Dialog
      maxWidthDialog={'md'}
      open={open}
      title={modalTitle}
      iconTitle={<CreateIcon />}
      style={errorMessage ? { display: 'none' } : {}}
      content={
        <StyledDivContent>
          <StyledInputTitle>Chauffeur</StyledInputTitle>

          <AutoComplete
            value={driver}
            onChange={(event, value) => {
              onSelect(value)
            }}
            id="Driver-list"
            options={drivers}
            getOptionLabel={(option) => `${option.firstname} ${option.lastname}`}
            variant="outlined"
            placeholder={'Chauffeur'}
            sxInputStyle={sxInput}
            renderOption={(props, option, index) => (
              <li key={index.index} id={`driver-${option.id}`} {...props}>
                <div className="AutoCompteFilterOption">
                  {`${option.firstname} ${option.lastname}`}
                </div>
              </li>
            )}
          />
          <div style={{ marginTop: '20px', width: '100%' }}>
            <StyledInputTitle>Clé </StyledInputTitle>{' '}
            <AutoComplete
              value={key}
              onChange={(event, value) => {
                onSelectKey(value)
              }}
              onInputChange={(event, value) => onChangeSearchKey(value)}
              id="Cle-Driver-list"
              options={keys}
              getOptionLabel={(option) => option.value}
              variant="outlined"
              placeholder={'Choisir une clé'}
              sxInputStyle={sxInput}
              ListboxProps={{
                onScroll: loadMoreKeys,
              }}
              renderOption={(props, option) => (
                <li id={`cle-${option.id}`} {...props}>
                  <div className="AutoCompteFilterOption">{`${option.value} -- ${option.label}`}</div>
                </li>
              )}
            />
          </div>
        </StyledDivContent>
      }
      handleClose={handleClose}
      handleClickAction={onChangeAssign}
      disabled={!key || !driver}
      isLoadingButtonAction={isLoadingAssign}
    />
  )
}
DriverModal.propTypes = {
  open: PropTypes.bool,
  handleClose: PropTypes.func,
  keys: PropTypes.array,
  modalTitle: PropTypes.string,
  drivers: PropTypes.array,
  fetchKeys: PropTypes.func,
  fetchDrivers: PropTypes.func,
  isLoadingDrivers: PropTypes.bool,
  searchKeys: PropTypes.func,
  assign: PropTypes.func,
  isLoadingAssign: PropTypes.bool,
  errorMessage: PropTypes.bool,
  success: PropTypes.bool,
  fetchMoreKeys: PropTypes.func,
  keysCount: PropTypes.number,
}

export default DriverModal
